import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { InfoBox } from '../../components/InfoBox';
interface CheckoutGoLivePageProps {
  onNavigate?: (pageId: string) => void;
}
export function CheckoutGoLivePage({
  onNavigate
}: CheckoutGoLivePageProps) {
  return <DocPageLayout title="Go-Live Checklist" data-id="element-1218">
      <div className="text-sm text-gray-500 mb-6 -mt-8" data-id="element-1219">
        <button onClick={() => onNavigate?.('overview')} className="hover:underline text-orange-600" data-id="element-1220">
          Overview
        </button>{' '}
        &gt;{' '}
        <button onClick={() => onNavigate?.('checkout')} className="hover:underline text-orange-600" data-id="element-1221">
          &lt;&lt;checkout&gt;&gt;
        </button>{' '}
        &gt; Go-Live Checklist
      </div>

      <p className="text-gray-700 mb-8" data-id="element-1222">
        Before switching your integration to the production environment, ensure
        you have completed all items in this checklist.
      </p>

      <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1223">
        Configuration
      </h2>
      <ul className="space-y-3 mb-8" data-id="element-1224">
        {['Update all API endpoints from test to production URLs', 'Replace test merchant credentials with production credentials', 'Update the Checkout.js script URL to the production gateway', 'Configure production webhook endpoints', 'Set the correct return and cancel URLs for production'].map((item, i) => <li key={i} className="flex items-start" data-id="element-1225">
            <span className="flex-shrink-0 w-5 h-5 border-2 border-gray-300 rounded mr-3 mt-0.5" data-id="element-1226"></span>
            <span className="text-gray-700" data-id="element-1227">{item}</span>
          </li>)}
      </ul>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1228">Security</h2>
      <ul className="space-y-3 mb-8" data-id="element-1229">
        {['Ensure all pages use HTTPS', 'Verify server-side result verification is implemented', 'Confirm API credentials are stored securely (not in client-side code)', 'Review Content Security Policy headers', 'Enable webhook signature verification'].map((item, i) => <li key={i} className="flex items-start" data-id="element-1230">
            <span className="flex-shrink-0 w-5 h-5 border-2 border-gray-300 rounded mr-3 mt-0.5" data-id="element-1231"></span>
            <span className="text-gray-700" data-id="element-1232">{item}</span>
          </li>)}
      </ul>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1233">Testing</h2>
      <ul className="space-y-3 mb-8" data-id="element-1234">
        {['Perform a live test transaction with a real card (small amount)', 'Verify the payment appears in the Merchant Administration portal', 'Test the complete flow: payment, capture, refund', 'Verify webhook notifications are received in production', 'Test on multiple browsers and devices'].map((item, i) => <li key={i} className="flex items-start" data-id="element-1235">
            <span className="flex-shrink-0 w-5 h-5 border-2 border-gray-300 rounded mr-3 mt-0.5" data-id="element-1236"></span>
            <span className="text-gray-700" data-id="element-1237">{item}</span>
          </li>)}
      </ul>

      <InfoBox type="warning" title="Production Credentials" data-id="element-1238">
        Never use test credentials in production or production credentials in
        the test environment. Keep your API password secure and rotate it
        regularly.
      </InfoBox>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1239">
        Production Endpoint
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1240">
        Your production gateway endpoint will be provided by your payment
        service provider. It will follow this format:
      </p>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-1241">
        https://{'{your-gateway}'}.mastercard.com/api/rest/version/72/merchant/
        {'{merchantId}'}
      </div>
    </DocPageLayout>;
}